import { Icon, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Box, IconButton } from 'native-base';
import React from 'react';

export interface HeaderProps {
  handleOpenInfo: () => void;
  isOpened: boolean;
  title: string;
}

export const Header: React.FC<HeaderProps> = ({ title, isOpened, handleOpenInfo }) => {
  return (
    <VStack>
      <HStack alignItems="center" justifyContent="space-between">
        <Text variant="semibold" fontSize={Typography['fontsize.md']} color="neutral.dark">
          {title}
        </Text>
        <IconButton
          p={0}
          variant="unstyled"
          onPress={handleOpenInfo}
          icon={
            <Icon
              testID="accordion-chevron-icon"
              name={isOpened ? 'ChevronUp' : 'ChevronDown'}
              size="xs"
              color={Color['neutral.dark']}
            />
          }
        />
      </HStack>
      <Box bg={'neutral.lightest'} h={0.8} mt={Spacing['inline.nano']} />
    </VStack>
  );
};
